import React, { useEffect, useState } from "react";
import { Form, Input, Select, Switch } from "antd";
import materialIconsList from "../../../constants/materialIcons";
import getIconByName from "../../../components/getIconByName";


const MenuForm = ({ form, espadre, setEspadre, childrenOptions }) => {
  // Remove the local materialIcons array since we're importing it

  useEffect(() => {
    if (!espadre) {
      form.setFieldValue('children', []);
    }
  }, [espadre, form]);
console.log("childrenOptions",childrenOptions);

  return (
    <Form form={form} layout="vertical">
      <Form.Item
        name="label"
        label="Nombre del Menú"
        rules={[{ required: true, message: "Por favor ingresa el nombre del menú" }]}
      >
        <Input />
      </Form.Item>

      <Form.Item
        name="slug"
        label="Slug"
        rules={[{ required: true, message: "Por favor ingresa el nombre del menú" }]}
      >
        <Input />
      </Form.Item>

      <Form.Item
        name="iconv"
        label="Ícono"
        rules={[{ required: true, message: "Por favor selecciona un ícono" }]}
      >
        <Select
          placeholder="Selecciona un ícono"
          showSearch
          optionFilterProp="label"
          filterOption={(input, option) =>
            option.label.toLowerCase().includes(input.toLowerCase())
          }
        >
          {materialIconsList.map((iconName) => (
            <Select.Option key={iconName} value={iconName} label={iconName}>
              <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
               {getIconByName(iconName)}
                {iconName}
              </div>
            </Select.Option>
          ))}
        </Select>
      </Form.Item>

      <Form.Item name="espadre" label="Es Padre" valuePropName="checked">
        <Switch checked={espadre} onChange={(checked) => setEspadre(checked)} />
      </Form.Item>

      {espadre && (
  <Form.Item
    name="children"
    label="Menús Hijos"
  >
    <Select
      mode="multiple"
      allowClear
      style={{ width: '100%' }}
      placeholder="Selecciona los menús hijos"
      optionFilterProp="label"
      value={form.getFieldValue('children')}
      options={childrenOptions.map(menu => ({
        value: menu.id,
        label: menu.label
      }))}
    />
  </Form.Item>
)}
    </Form>
  );
};

export default MenuForm;